import { render, staticRenderFns } from "./HelpForm.vue?vue&type=template&id=581a09d9&scoped=true&"
import script from "./HelpForm.vue?vue&type=script&lang=js&"
export * from "./HelpForm.vue?vue&type=script&lang=js&"
import style0 from "./HelpForm.vue?vue&type=style&index=0&id=581a09d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a09d9",
  null
  
)

export default component.exports